import { crudMdActions } from "@/services/crud-md-actions";

const name = "localizations";

export default {
  name,
  ...crudMdActions(name),
};
